// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Heart } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconHeart(props: any) {
    return <IconBase icon={Heart} {...props} />
  }

  export default IconHeart
  